// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageReservationDetails {
  background: rgba(20, 20, 43, 0.75);
  width: 95%;
  display: flex;
  margin-top: 1rem;
  flex-direction: column;
  border: 2px solid transparent;
  -webkit-font-smoothing: antialiased;
  background-clip: padding-box;
  -moz-osx-font-smoothing: grayscale;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(2em);
  padding: 1.5em;
  border-radius: 1em;
  z-index: 100;
  color: var(--clr-light);
  left: 0;
  right: 0;
  top: 100%;
  margin: 0 auto;
}

.messageReservationDetails.summary {
  padding: 0;
  background: transparent;
  color: #000;
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.messageReservationDetails.summary .messageReservationDetails__quote {
  overflow-wrap: break-word;
}

.messageReservationDetails.summary ul {
  display: flex;
  flex-direction: column;
}

.messageReservationDetails.summary .messageReservationDetails__details li img {
  filter: invert(1);
}
.messageReservationDetails.summary .messageReservationDetails__detail.gift img {
  filter: unset;
}

.messageReservationDetails.relative {
  position: relative !important;
  width: 35rem;
}

.messageReservationDetails .loading-container-text {
  font-size: 0.75rem;
  padding-top: 2em;
}

.messageReservationDetails.desktop {
  display: none;
}

.messageReservationDetails h4 {
  font-size: 0.9rem;
  font-weight: bold;
  color: var(--clr-light);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.messageReservationDetails h4 span {
  cursor: pointer;
  font-size: 0.7rem;
  display: block;
  text-transform: unset !important;
}

.messageReservationDetails__details {
  display: grid;
  gap: 0.5rem;
  margin-top: 1rem;
  grid-auto-flow: column;
  grid-template-rows: repeat(4, minmax(1rem, 1fr));
}

.messageReservationDetails__details li {
  font-size: 0.9rem;
  display: flex;
  height: 1.5rem;
  align-items: center;
}

.messageReservationDetails__detail.show .chevron {
  transform: rotate(180deg);
}

.messageReservationDetails__detail > div {
  display: flex;
  width: 100%;
  align-items: center;
}

.messageReservationDetails__details li img {
  margin-right: 0.5rem;
  width: 100%;
  max-width: 1.25rem;
}

.messageReservationDetails__detail.gift img {
  filter: invert(1);
}

.messageReservationDetails__quote {
  font-size: 0.85rem;
  display: block;
  margin-top: 1rem;
}

.messageReservationDetails__btnContainer {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.messageReservationDetails__btnPayment a,
.messageReservationDetails__btnContainer button {
  border-radius: 0.5em;
  justify-content: center;
  align-items: center;
  text-align: center;
  display: flex;
  font-weight: bold;
  background: transparent;
  border: 2px solid var(--clr-light);
  font-size: 0.7rem;
  padding: 1em 1.5em;
  color: #fff;
}

.messageReservationDetails__btnPayment {
  padding: 0;
  background-color: transparent;
  border-radius: 0;
}

.messageReservationDetails__errorPayment {
  font-size: 0.7rem;
  padding: 1em 1.5em;
  color: var(--clr-error-dark);
  background: var(--clr-error);
  display: block;
  margin-top: 0.5rem;
  border-radius: 0.5em;
}

.messageReservationDetails__errorPayment a {
  text-decoration: underline;
}

.messageReservationDetails__btnPayment a {
  width: 100%;
  border: none;
  background: var(--clr-primary);
  font-size: 0.8rem;
  margin-top: 0.5rem;
  color: #fff !important;
}

.messageReservationDetails__btnPayment:disabled a,
.messageReservationDetails__btnContainer button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.messageReservationDetails__btnPayment:disabled .loading-animation,
.messageReservationDetails__btnContainer button:disabled .loading-animation {
  left: 0;
}

.messageReservationDetails__btnPayment .loading-button-decline,
.messageReservationDetails__btnContainer .loading-button-decline {
  padding: 0.65em 1.25em;
}

.messageReservationDetails__btnContainer button:first-of-type {
  background: var(--clr-primary);
  margin-right: 1rem;
  max-width: 12rem;
  border: none;
  width: 100%;
}

.messageReservationDetails__btnContainer i {
  margin-right: 1rem;
}

.messageReservationDetails__btnContainer .cross-mark {
  width: 0.5rem;
  margin-left: 0;
  height: 0.5rem;
  margin-bottom: 0.5rem;
}

.messageReservationDetails__btnContainer .cross-mark::after,
.messageReservationDetails__btnContainer .cross-mark::before {
  background: var(--clr-light);
}

.messageReservationDetails__detailsQuote svg {
  width: 1.15rem;
  margin-right: 0.5rem;
}

.messageReservationDetails__detailsQuote {
  display: flex;
  align-items: center;
  padding: 0.75em 1em;
  font-size: 0.8rem;
  font-weight: bold;
  margin-top: 1rem;
  justify-content: center;
  border-radius: 0.5em;
}

.messageReservationDetails__detailsQuote.accepted {
  background: var(--clr-success);
  color: var(--clr-success-dark);
}

.messageReservationDetails__detailsQuote.pending {
  background: var(--clr-warning);
  color: var(--clr-warning-dark);
}

.messageReservationDetails__detail .chevron {
  margin-left: 0.5rem;
  margin-top: 0;
  max-width: 1rem;
}
.messageReservationDetails__detail.cursor-click {
  cursor: pointer;
  flex-direction: column;
  height: 100%;
}
.messageReservationDetails__detail.cursor-click li {
  height: 100%;
}

@media (min-width: 768px) {
  .messageReservationDetails__btnContainer button {
    font-size: 0.8rem;
  }
}
@media (min-width: 992px) {
  .messageReservationDetails {
    position: absolute;
  }

  .messageReservationDetails.desktop {
    display: flex;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageComponents/MessageReservationDetails/MessageReservationDetails.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;EAC5B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,kCAA6B;EAA7B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAIlB,sBAAsB;AAHxB;;AAMA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;AACT;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".messageReservationDetails {\n  background: rgba(20, 20, 43, 0.75);\n  width: 95%;\n  display: flex;\n  margin-top: 1rem;\n  flex-direction: column;\n  border: 2px solid transparent;\n  -webkit-font-smoothing: antialiased;\n  background-clip: padding-box;\n  -moz-osx-font-smoothing: grayscale;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(2em);\n  padding: 1.5em;\n  border-radius: 1em;\n  z-index: 100;\n  color: var(--clr-light);\n  left: 0;\n  right: 0;\n  top: 100%;\n  margin: 0 auto;\n}\n\n.messageReservationDetails.summary {\n  padding: 0;\n  background: transparent;\n  color: #000;\n  width: fit-content !important;\n}\n.messageReservationDetails.summary .messageReservationDetails__quote {\n  overflow-wrap: break-word;\n}\n\n.messageReservationDetails.summary ul {\n  display: flex;\n  flex-direction: column;\n}\n\n.messageReservationDetails.summary .messageReservationDetails__details li img {\n  filter: invert(1);\n}\n.messageReservationDetails.summary .messageReservationDetails__detail.gift img {\n  filter: unset;\n}\n\n.messageReservationDetails.relative {\n  position: relative !important;\n  width: 35rem;\n}\n\n.messageReservationDetails .loading-container-text {\n  font-size: 0.75rem;\n  padding-top: 2em;\n}\n\n.messageReservationDetails.desktop {\n  display: none;\n}\n\n.messageReservationDetails h4 {\n  font-size: 0.9rem;\n  font-weight: bold;\n  color: var(--clr-light);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.messageReservationDetails h4 span {\n  cursor: pointer;\n  font-size: 0.7rem;\n  display: block;\n  text-transform: unset !important;\n}\n\n.messageReservationDetails__details {\n  display: grid;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  grid-auto-flow: column;\n  grid-template-rows: repeat(4, minmax(1rem, 1fr));\n}\n\n.messageReservationDetails__details li {\n  font-size: 0.9rem;\n  display: flex;\n  height: 1.5rem;\n  align-items: center;\n}\n\n.messageReservationDetails__detail.show .chevron {\n  transform: rotate(180deg);\n}\n\n.messageReservationDetails__detail > div {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.messageReservationDetails__details li img {\n  margin-right: 0.5rem;\n  width: 100%;\n  max-width: 1.25rem;\n}\n\n.messageReservationDetails__detail.gift img {\n  filter: invert(1);\n}\n\n.messageReservationDetails__quote {\n  font-size: 0.85rem;\n  display: block;\n  margin-top: 1rem;\n}\n\n.messageReservationDetails__btnContainer {\n  display: flex;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.messageReservationDetails__btnPayment a,\n.messageReservationDetails__btnContainer button {\n  border-radius: 0.5em;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  display: flex;\n  font-weight: bold;\n  background: transparent;\n  border: 2px solid var(--clr-light);\n  font-size: 0.7rem;\n  padding: 1em 1.5em;\n  color: #fff;\n}\n\n.messageReservationDetails__btnPayment {\n  padding: 0;\n  background-color: transparent;\n  border-radius: 0;\n}\n\n.messageReservationDetails__errorPayment {\n  font-size: 0.7rem;\n  padding: 1em 1.5em;\n  color: var(--clr-error-dark);\n  background: var(--clr-error);\n  display: block;\n  margin-top: 0.5rem;\n  border-radius: 0.5em;\n}\n\n.messageReservationDetails__errorPayment a {\n  text-decoration: underline;\n}\n\n.messageReservationDetails__btnPayment a {\n  width: 100%;\n  border: none;\n  background: var(--clr-primary);\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n}\n\n.messageReservationDetails__btnPayment a {\n  color: #fff !important;\n}\n\n.messageReservationDetails__btnPayment:disabled a,\n.messageReservationDetails__btnContainer button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.messageReservationDetails__btnPayment:disabled .loading-animation,\n.messageReservationDetails__btnContainer button:disabled .loading-animation {\n  left: 0;\n}\n\n.messageReservationDetails__btnPayment .loading-button-decline,\n.messageReservationDetails__btnContainer .loading-button-decline {\n  padding: 0.65em 1.25em;\n}\n\n.messageReservationDetails__btnContainer button:first-of-type {\n  background: var(--clr-primary);\n  margin-right: 1rem;\n  max-width: 12rem;\n  border: none;\n  width: 100%;\n}\n\n.messageReservationDetails__btnContainer i {\n  margin-right: 1rem;\n}\n\n.messageReservationDetails__btnContainer .cross-mark {\n  width: 0.5rem;\n  margin-left: 0;\n  height: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.messageReservationDetails__btnContainer .cross-mark::after,\n.messageReservationDetails__btnContainer .cross-mark::before {\n  background: var(--clr-light);\n}\n\n.messageReservationDetails__detailsQuote svg {\n  width: 1.15rem;\n  margin-right: 0.5rem;\n}\n\n.messageReservationDetails__detailsQuote {\n  display: flex;\n  align-items: center;\n  padding: 0.75em 1em;\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin-top: 1rem;\n  justify-content: center;\n  border-radius: 0.5em;\n}\n\n.messageReservationDetails__detailsQuote.accepted {\n  background: var(--clr-success);\n  color: var(--clr-success-dark);\n}\n\n.messageReservationDetails__detailsQuote.pending {\n  background: var(--clr-warning);\n  color: var(--clr-warning-dark);\n}\n\n.messageReservationDetails__detail .chevron {\n  margin-left: 0.5rem;\n  margin-top: 0;\n  max-width: 1rem;\n}\n.messageReservationDetails__detail.cursor-click {\n  cursor: pointer;\n  flex-direction: column;\n  height: 100%;\n}\n.messageReservationDetails__detail.cursor-click li {\n  height: 100%;\n}\n\n@media (min-width: 768px) {\n  .messageReservationDetails__btnContainer button {\n    font-size: 0.8rem;\n  }\n}\n@media (min-width: 992px) {\n  .messageReservationDetails {\n    position: absolute;\n  }\n\n  .messageReservationDetails.desktop {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
